<template>
	<div class="userpage" :class="($store.state.mode === 'dark') ? 'userpage-dark' : 'false'">
		<div class="navbar" :class="($store.state.mode === 'dark') ? 'dark-header-active' : 'false'">
			<i v-on:click="$router.go(-1)" class="material-icons">arrow_back</i>
			<div class="title">
				Privacy Policy
			</div>
			<i v-on:click="$router.push('/Support')" class="material-icons">help</i>
		</div>

		<div class="submenu--wrapper">
			<div class="head">	
				<div class="title">
					Privacy Policy
				</div>
				<span class="desc">Last updated: Jun 30, 2020</span>
			</div>
			<div class="body-content">
				<div class="sub-title">
					Islamic built the an app as an Ad Supported app. This SERVICE is provided by Islamic at no cost and is intended for use as is.
				</div>
			</div>
			<div class="body-content">
				<div class="sub-title">
					This page is used to inform visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service.
				</div>
			</div>
			<div class="body-content">
				<div class="sub-title">
					If you choose to use our Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that we collect is used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy.
				</div>
			</div>
			<div class="body-content">
				<div class="sub-title">
					The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at JiTube unless otherwise defined in this Privacy Policy.
				</div>
			</div>
			<div class="body-content">
				<div class="sub-title">
					For a better experience, while using our Service, we may require you to provide us with certain personally identifiable information, including but not limited to Audio, Podcast, Islamic. The information that we request will be retained by us and used as described in this privacy policy.
					The app does use third party services that may collect information used to identify you.
				</div>
			</div>
			<br>
			<div class="body-content">
				<div class="title">
					Log Data
				</div>
			</div>
			<div class="body-content">
				<div class="sub-title">
					We want to inform you that whenever you use our Service, in a case of an error in the app we collect data and information (through third party products) on your phone called Log Data. This Log Data may include information such as your device Internet Protocol (“IP”) address, device name, operating system version, the configuration of the app when utilizing our Service, the time and date of your use of the Service, and other statistics.
				</div>
			</div>
			<br>
			<div class="body-content">
				<div class="title">
					Cookies
				</div>
			</div>
			<div class="body-content">
				<div class="sub-title">
					Cookies are files with a small amount of data that are commonly used as anonymous unique identifiers. These are sent to your browser from the websites that you visit and are stored on your device's internal memory.
				</div>
			</div>
			<div class="body-content">
				<div class="sub-title">
					This Service does not use these “cookies” explicitly. However, the app may use third party code and libraries that use “cookies” to collect information and improve their services. You have the option to either accept or refuse these cookies and know when a cookie is being sent to your device. If you choose to refuse our cookies, you may not be able to use some portions of this Service.
				</div>
			</div>
			<br>
			<div class="body-content">
				<div class="title">
					Services Provider
				</div>
			</div>
			<div class="body-content">
				<div class="sub-title">
					We may employ third-party companies and individuals due to the following reasons:
				</div>
			</div>
			<div class="body-content">
				<div class="sub-title">
					To facilitate our Service;
					To provide the Service on our behalf;
					To perform Service-related services; or
					To assist us in analyzing how our Service is used.
				</div>
			</div>
			<div class="body-content">
				<div class="sub-title">
					We want to inform users of this Service that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.
				</div>
			</div>
			<br>
			<div class="body-content">
				<div class="title">
					Security
				</div>
			</div>
			<div class="body-content">
				<div class="sub-title">
					We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.
				</div>
			</div>
			<br>
			<div class="body-content">
				<div class="title">
					Links to Other Sites
				</div>
			</div>
			<div class="body-content">
				<div class="sub-title">
					This Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.
				</div>
			</div>
			<br>
			<div class="body-content">
				<div class="title">
					Changes to This Privacy Policy
				</div>
			</div>
			<div class="body-content">
				<div class="sub-title">
					We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately after they are posted on this page.
				</div>
			</div>
			<br>
			<div class="body-content">
				<div class="title">
					Contact Us
				</div>
			</div>
			<div class="body-content">
				<div class="sub-title">
					If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us at djourneyofadam@gmail.com
				</div>
			</div>
			<div class="body-content">
				<div class="sub-title">
					This Terms and Conditions page was generated by
					<a href="https://privacypolicytemplate.net" target="_blank">Privacy Policy Template</a>
						and modified/generated by
					<a href="https://app-privacy-policy-generator.firebaseapp.com/" target="_blank">App Privacy Policy Generator</a>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			mode: null,
		}
	},
	mounted() {
		this.mode = localStorage.mode
	},

};
</script>